import React from 'react'
import Subheader from '../../component/Subheader'
import RoomFeature from '../RoomListing/RoomFeature'
import RoomLists from '../RoomListing/RoomLists'

export default function RoomlistingRishikesh() {
  const subheadData = {
    heading: 'Rooms & Suites in De Coracao',
    breadcrumb: [
      {
        slug: "/resort-de-coracao-rishikesh",
        name: "Rishikesh",
      },
      {
        slug: "",
        name: "Rooms",
      },
    ]
  }


  const roomList = [
    {
      category: "Deluxe",
      title: "Deluxe",
      description: "Enjoy a cosy and inviting stay with modern amenities, comfortable interiors, and a relaxing ambience, perfect for leisure and short getaways.",
      image: "/image/rishikesh-deluxe-img.webp",
      enquireLink: "/contact-us",
      bookLink: "https://www.swiftbook.io/inst/#/home?propertyId=682NTPc7dd5tQYOO7KblEIVgpgsly1qSD956Ilzg2MDU=&JDRN=Y&RoomID=255031,255032,255033,255034,255035&ap=1&gsId=682NTPc7dd5tQYOO7KblEIVgpgsly1qSD956Ilzg2MDU=",
      detailLink: "/resort-de-coracao-rishikesh/deluxe",
      specs: [
        "1 King Size Bed",
        "2 Guests Occupancy",
        "21 m² Room Area",
      ],
    },

    {
      category: "Super Deluxe",
      title: "Super Deluxe",
      description: "Spacious and elegantly designed, the room offers modern comforts, stylish interiors, and a peaceful ambience for a truly relaxing stay.",
      image: "/image/rishikesh-superdeluxe-img.webp",
      enquireLink: "/contact-us",
      bookLink: "https://www.swiftbook.io/inst/#/home?propertyId=682NTPc7dd5tQYOO7KblEIVgpgsly1qSD956Ilzg2MDU=&JDRN=Y&RoomID=255031,255032,255033,255034,255035&ap=1&gsId=682NTPc7dd5tQYOO7KblEIVgpgsly1qSD956Ilzg2MDU=",
      detailLink: "/resort-de-coracao-rishikesh/super-deluxe",
      specs: [
        "1 King Size Bed",
        "3 Guests Occupancy",
        "26 m² Room Area",
      ],
    },
    {
      category: "Premium Suite",
      title: "Premium Suite",
      description: "Experience elevated luxury with spacious living, sophisticated interiors, premium amenities, designed for complete relaxation and comfort.",
      image: "/image/rishikesh-premium-suite-img.webp",
      enquireLink: "/contact-us",
      bookLink: "https://www.swiftbook.io/inst/#/home?propertyId=682NTPc7dd5tQYOO7KblEIVgpgsly1qSD956Ilzg2MDU=&JDRN=Y&RoomID=255031,255032,255033,255034,255035&ap=1&gsId=682NTPc7dd5tQYOO7KblEIVgpgsly1qSD956Ilzg2MDU=",
      detailLink: "/resort-de-coracao-rishikesh/premium-suite",
      specs: [
        "1 King Size Bed",
        "3 Guests Occupancy",
        "30 m² Room Area",
      ],
    },

    {
      category: "Suite",
      title: "Suite",
      description: "Thoughtfully designed with spacious interiors and refined furnishings, it offers premium comfort, elegance, and a welcoming retreat in Rishikesh.",
      image: "/image/rishikesh-suite-img.webp",
      enquireLink: "/contact-us",
      bookLink: "https://www.swiftbook.io/inst/#/home?propertyId=682NTPc7dd5tQYOO7KblEIVgpgsly1qSD956Ilzg2MDU=&JDRN=Y&RoomID=255031,255032,255033,255034,255035&ap=1&gsId=682NTPc7dd5tQYOO7KblEIVgpgsly1qSD956Ilzg2MDU=",
      detailLink: "/resort-de-coracao-rishikesh/suite",
      specs: [
        "1 King Size Bed",
        "3 Guests Occupancy",
        "33 m² Room Area",
      ],
    },

    

    {
      category: "Ganga Suite",
      title: "Ganga Suite",
      description: "Indulge in the finest luxury with elegant interiors, generous space, premium comforts, and a tranquil atmosphere inspired by Rishikesh's timeless charm.",
      image: "/image/rishikesh-ganga-suite-img.webp",
      enquireLink: "/contact-us",
      bookLink: "https://www.swiftbook.io/inst/#/home?propertyId=682NTPc7dd5tQYOO7KblEIVgpgsly1qSD956Ilzg2MDU=&JDRN=Y&RoomID=255031,255032,255033,255034,255035&ap=1&gsId=682NTPc7dd5tQYOO7KblEIVgpgsly1qSD956Ilzg2MDU=",
      detailLink: "/resort-de-coracao-rishikesh/ganga-suite",
      specs: [
        "1 King Size Bed",
        "3 Guests Occupancy",
        "30 m² Room Area",
      ],
    },
  ];


const roomFeatureData = {
  features1: [
    {
      icon: "/image/room-feature-icon-1.webp",
      text: "Experience warm, personalized service that makes your Rishikesh stay welcoming, peaceful, and memorable.",
    },
    {
      icon: "/image/room-feature-icon-2.webp",
      text: "Unwind in serene outdoor spaces created for reflection, relaxation, and connection with nature.",
    },
    {
      icon: "/image/room-feature-icon-3.webp",
      text: "Enjoy thoughtfully prepared dishes featuring fresh ingredients, vibrant flavours, and memorable dining experiences.",
    },
  ],

  features2: [
    {
      icon: "/image/room-feature-icon-4.webp",
      text: "Discover accommodation designed to help you slow down, restore balance, and enjoy your Rishikesh getaway.",
    },
    {
      icon: "/image/room-feature-icon-5.webp",
      text: "Beautifully curated interiors combine natural materials and refined details to reflect Rishikesh’s tranquil spirit.",
    },
    {
      icon: "/image/room-feature-icon-6.webp",
      text: "Browse stay listings offering comfortable rooms, premium amenities, and restful spaces after exploring Rishikesh.",
    },
  ],
};

  return (
    <>
      <Subheader subheadData={subheadData} />
      <RoomLists roomList={roomList} />
      <RoomFeature data={roomFeatureData}/>
    </>
  )
}
